import { IWorkspace } from "models/IWorkspace";

export interface IAddDocumentsDialogProps {
  isOpen: boolean;
  workspace: IWorkspace;
  onClose: () => void;
  canDelete?: boolean;
}

export interface IUploadingFile {
  id: string;
  file: File;
  originalFilename: string;
  status: "uploading" | "uploaded" | "error";
  blobFilename?: string;
}

export const DIALOG_LABELS = {
  TITLE: "Add Documents",
  DROPZONE_TEXT: "Drag and drop files here",
  DROPZONE_OR: "or",
  BROWSE_FILES: "Browse Files",
  ACCEPTED_TYPES: "Accepted file types:",
  CANCEL: "Cancel",
  DONE: "Done",
  UPLOADED: "Uploaded",
  UPLOADING: "Uploading...",
  DELETING: "Deleting...",
  ERROR: "Upload failed",
} as const;

export const DELETE_CONFIRM = {
  TITLE: "Delete Document",
  MESSAGE: (filename: string) =>
    `Are you sure you want to delete "${filename}"? This action cannot be undone.`,
  ACTION: "Delete",
  DISMISS: "Cancel",
  FAILED_MESSAGE: "Failed to download document. Please try again.",
} as const;
